import React from 'react';
import styles from './fncControlErrorMessage.module.scss';
import { tErrorKey } from '../../../helpers/translate';

const FncControlErrorMessage = ({ message }: { message: string | JSX.Element }) => (
  <p className={styles.error}>{tErrorKey(message as string)}</p>
);

export default FncControlErrorMessage;
